import React, { createRef, useContext, useEffect, useState } from 'react'
import { AppContext } from "../context/AppContext";
import {
  getGroups,
  createGroup,
  updateGroup,
  getUser,
  deleteGroup,
  getDepartments,
  updateDepartment,
  createDepartment,
  deleteDepartment,
} from "../services/adminServices";
import { CONFIG } from '../config/general';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import DropdownWithCheckbox from './Selection';

const Department = () => {
  const { login } = useContext(AppContext);
  const [groups, setGroups] = useState([]);
  const [validatorCount, setValidatorCount] = useState(0);
  const forceUpdate = () => setValidatorCount(validatorCount + 1);
  const initial = new SimpleReactValidator({ locale: "en", autoForceUpdate: { forceUpdate } });
  const [validator, setValidator] = useState(initial);
  const [pagination, setPagination] = useState({});
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState({ name: "", limit: 10, page: 1 });
  const [editGroup, setEditGroup] = useState(null);
  const [newGroup, setNewGroup] = useState({
    name: "",
    desc: "",
    members: [],
  });
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);

  const getAllGroups = async (filters = filter) => {
    try {
      let result = await getDepartments(login.token, filters);
      setPagination(result.pagination)
      setGroups(result.data.map((x) => ({ ...x, isGroup: true })));
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  const getAllUsers = async () => {
    try {
      let result = await getUser(login.token, { name: "" });
      setUsers(result.data.map((x) => ({ ...x, isGroup: false })));
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleCreateGroup = async () => {
    try {
      if (validator.allValid()) {
        const result = await createDepartment(login.token, newGroup);
        if (result.success) {
          toast.success(result.message)
        } else {
          toast.error(result.message)
        }
        setNewGroup({
          name: "",
          desc: "",
          members: [],
        });
        getAllGroups();
        setIsGroupModalOpen(false);
      } else {
        validator.showMessages();
        forceUpdate();
      }
    } catch (error) {
      console.error("Error creating member:", error);
      toast.error("Something went wrong")
    }
  };

  const handleUpdateGroup = async () => {
    try {
      if (validator.allValid()) {
        const result = await updateDepartment(login.token, editGroup._id, editGroup);
        if (result.success) {
          toast.success(result.message)
        } else {
          toast.error(result.message)
        }
        setEditGroup(null);
        getAllGroups();
      } else {
        validator.showMessages();
        forceUpdate();
      }
    } catch (error) {
      console.error("Error updating group:", error);
      toast.error("Something went wrong")
    }
  };

  const handleNext = () => {
    if (pagination.currentPage < pagination.totalPages) {
      const newPage = pagination.currentPage + 1;
      setFilter({ ...filter, page: newPage });
      getAllGroups({ ...filter, page: newPage });
    }
  };

  const handlePrev = () => {
    if (pagination.currentPage > 1) {
      const newPage = pagination.currentPage - 1;
      setFilter({ ...filter, page: newPage });
      getAllGroups({ ...filter, page: newPage });
    }
  };

  const handleDeleteDept = async (id) => {
    try {
      let result = await deleteDepartment(login.token, id)
      if (result.success) {
        toast.success(result.message)
      } else {
        toast.error(result.message)
      }
      getAllGroups()
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setGroups([]);
    getAllGroups();
    getAllUsers();
  }, []);

  useEffect(() => {
    getAllGroups();
  }, [filter.limit]);

  validator.purgeFields();

  return (
    <div className="details-table mt-3">
      <div className="search-container">
        <h4>
          <i class="fas fa-building"></i> Department Details :
        </h4>
        <div className="headerWrap gap-3">
          <form onSubmit={(e) => {
            e.preventDefault();
            getAllGroups();
          }} className="d-flex">
            <button type="submit" id="searchButton" style={{ background: "none", border: "none", padding: 0 }}>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M11.5 21.5C16.7467 21.5 21 17.2467 21 12C21 6.75329 16.7467 2.5 11.5 2.5C6.25329 2.5 2 6.75329 2 12C2 17.2467 6.25329 21.5 11.5 21.5Z" stroke="#657488" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M22 22.5L20 20.5" stroke="#657488" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
            </button>
            <input
              className="fs-18 tableSearch"
              type="text"
              value={filter.name}
              onChange={(e) => setFilter({ ...filter, name: e.target.value })}
              id="searchInput"
              name="search"
              placeholder="Search here . . ."
            />
          </form>
          <div className="add-user py-3 text-end">
            <h4>
              <a onClick={() => setIsGroupModalOpen(true)}>
                <i class="fas fa-building"></i>
              </a>
            </h4>
          </div>
        </div>
      </div>
      <div className="custom-pagination">
        <div className="d-flex gap-2 align-items-center">
          <span className="showing-entries">Showing {(pagination.currentPage - 1) * filter.limit + 1} - {Math.min((pagination.currentPage) * filter.limit, pagination.totalGroups)} of {pagination.totalGroups}</span>
          <div className="dropdown">
            <button
              className="btn btn-sm btn-outline-secondary dropdown-toggle w-100"
              type="button"
              id="limitDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {filter.limit || "Select Limit"}
            </button>

            <ul className="dropdown-menu w-100" aria-labelledby="limitDropdown">
              {[10, 20, 50, 100].map((val) => (
                <li key={val}>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => setFilter({ ...filter, limit: val })}
                  >
                    {val}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="page-controls">
          <button
            className="page-btn prev"
            onClick={handlePrev}
            disabled={pagination.currentPage === 1} // Disable button on first page
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <span className="current-page">{pagination.currentPage}</span>
          <span className="separator">/</span>
          <span className="total-pages">{pagination.totalPages}</span>
          <button
            className="page-btn next"
            onClick={handleNext}
            disabled={pagination.currentPage === pagination.totalPages} // Disable button on last page
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <table id="example" className="display" style={{ "width": "100%" }}>
        <thead>
          <tr>
            <th style={{ maxWidth: "20px" }}>No</th>
            <th style={{ maxWidth: "70px" }}>Department Name</th>
            <th>Users</th>
            <th style={{ width: "252px" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {
            groups.map((x, i) => {
              return (
                <tr key={x._id}>
                  <td>{((pagination.currentPage - 1) * filter.limit) + (i + 1)}</td>
                  <td>{x.name}</td>
                  <td>
                    {(x.members && x.members.length > 0)
                      ? x.members.map((member, i) => (
                        <span key={i}>
                          {member.name}{i !== x.members.length - 1 ? ", " : ""}
                        </span>
                      ))
                      : "Not Added"}
                  </td>

                  <td>
                    <div className="export-chat edit-delete-user">
                      <a
                        onClick={() =>
                          setEditGroup({
                            ...x,
                            members: x.members.map((x) => x._id),
                          })
                        }>
                        <i className="fa-regular fa-pen-to-square"></i>Edit
                      </a>
                      <a
                        onClick={() => handleDeleteDept(x._id)}>
                        <i className="fa-regular fa-pen-to-square"></i>Delete
                      </a>
                    </div>
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
      {isGroupModalOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Create New Department</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setIsGroupModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                {/* Group Name */}
                <div className="mb-3">
                  <label className="form-label">Department Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Department Name"
                    value={newGroup.name}
                    onChange={(e) =>
                      setNewGroup({ ...newGroup, name: e.target.value })
                    }
                  />
                  <span className="text-danger small">{validator.message("Name", newGroup.name, "required|max:50", { max: "Name cannot exceed 50 characters." })}</span>
                </div>

                {/* Group Description */}
                <div className="mb-3">
                  <label className="form-label">Department Description</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Department Description"
                    value={newGroup.desc}
                    onChange={(e) =>
                      setNewGroup({ ...newGroup, desc: e.target.value })
                    }
                  />
                  <span className="text-danger small">{validator.message("Description", newGroup.desc, "required|max:150", { max: "Description cannot exceed 150 characters." })}</span>
                </div>

                {/* Select Members */}
                <div className="mb-3">
                  <label className="form-label">Select Members</label>
                  <DropdownWithCheckbox options={users} selectedItems={newGroup.members} setSelectedItems={(data) => { setNewGroup({ ...newGroup, "members": data }) }} />
                </div>

                {/* Display Selected Members */}
                {newGroup.members.length > 0 && (
                  <div className="mb-3">
                    <label className="form-label">Selected Members</label>
                    <div className="d-flex flex-wrap gap-1">
                      {newGroup.members.map((memberId) => {
                        const member = users.find((user) => user._id === memberId);
                        return (
                          <span
                            key={memberId}
                            className="badge bg-primary d-flex align-items-center"
                          >
                            {member?.name || "Unknown"}
                            <button
                              type="button"
                              className="btn btn-sm btn-close btn-close-white ms-2"
                              aria-label="Remove"
                              onClick={() => {
                                setNewGroup({
                                  ...newGroup,
                                  members: newGroup.members.filter((id) => id !== memberId),
                                });
                              }}
                              style={{ fontSize: '0.7rem' }}
                            ></button>
                          </span>
                        );
                      })}
                    </div>
                  </div>
                )}

              </div>

              {/* Modal Footer */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setIsGroupModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleCreateGroup}
                  style={{ backgroundColor: '#1edd60', border: "none" }}
                >
                  Create Department
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {
        editGroup && (
          <div className="modal show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Group</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setEditGroup(null)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editGroup.name}
                      onChange={(e) =>
                        setEditGroup({ ...editGroup, name: e.target.value })
                      }
                    />
                    <span className="text-danger small">{validator.message("Name", editGroup.name, "required|max:50", { max: "Name cannot exceed 50 characters." })}</span>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editGroup.desc}
                      onChange={(e) =>
                        setEditGroup({ ...editGroup, desc: e.target.value })
                      }
                    />
                    <span className="text-danger small">{validator.message("Description", editGroup.desc, "required|max:150", { max: "Description cannot exceed 150 characters." })}</span>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Select Members</label>
                    <DropdownWithCheckbox options={users} selectedItems={editGroup.members} setSelectedItems={(data) => { setEditGroup({ ...editGroup, "members": data }) }} />
                    <span className="text-danger small"> {validator.message(
                      "Member",
                      editGroup.members,
                      `required`
                    )}</span>
                  </div>
                  {editGroup.members.length > 0 && (
                    <div className="mb-3">
                      <label className="form-label">Selected Members</label>
                      <div className="d-flex flex-wrap gap-1">
                        {editGroup.members.map((memberId) => {
                          const member = users.find((user) => user._id === memberId);
                          return (
                            <span
                              key={memberId}
                              className="badge bg-primary d-flex align-items-center"
                            >
                              {member?.name || "Unknown"}
                              <button
                                type="button"
                                className="btn btn-sm btn-close btn-close-white ms-2"
                                aria-label="Remove"
                                onClick={() => {
                                  setEditGroup({
                                    ...editGroup,
                                    members: editGroup.members.filter((id) => id !== memberId),
                                  });
                                }}
                                style={{ fontSize: '0.7rem' }}
                              ></button>
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  )}

                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setEditGroup(null)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleUpdateGroup}
                    style={{ backgroundColor: '#1edd60', border: "none" }}
                  >
                    Update Group
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div >
  )
}

export default Department
